/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Destination } from './Destination';
import {
    DestinationFromJSON,
    DestinationFromJSONTyped,
    DestinationToJSON,
} from './Destination';
import type { ERP } from './ERP';
import {
    ERPFromJSON,
    ERPFromJSONTyped,
    ERPToJSON,
} from './ERP';
import type { GeoJson } from './GeoJson';
import {
    GeoJsonFromJSON,
    GeoJsonFromJSONTyped,
    GeoJsonToJSON,
} from './GeoJson';
import type { Source } from './Source';
import {
    SourceFromJSON,
    SourceFromJSONTyped,
    SourceToJSON,
} from './Source';
import type { TrackResultTrack } from './TrackResultTrack';
import {
    TrackResultTrackFromJSON,
    TrackResultTrackFromJSONTyped,
    TrackResultTrackToJSON,
} from './TrackResultTrack';

/**
 * Notice not all parameters are always set. route: Linestring indicating the automatic route calculated. Notice presence of this field is dependent on system configuration and user access rights. geo: Polygon showing the expected arrival of the ship in the port.
 * @export
 * @interface TrackResult
 */
export interface TrackResult {
    /**
     * 
     * @type {number}
     * @memberof TrackResult
     */
    id?: number;
    /**
     * A status code indicating the current tracking status. https://maritime.gatehouse.dk/pub/api-doc/portserver/
     * @type {number}
     * @memberof TrackResult
     */
    code?: number;
    /**
     * 
     * @type {GeoJson}
     * @memberof TrackResult
     */
    route?: GeoJson;
    /**
     * Estimated Time of Arrival (ETA) in ISO Extended format
     * @type {Date}
     * @memberof TrackResult
     */
    eta?: Date;
    /**
     * ERP system Estimated Time of Arrival in ISO Extended format
     * @type {Date}
     * @memberof TrackResult
     */
    etaErp?: Date;
    /**
     * Actual Time of Arrival from AIS in ISO Extended format
     * @type {Date}
     * @memberof TrackResult
     */
    ataAis?: Date;
    /**
     * Actual Time of Departure from AIS in ISO Extended format
     * @type {Date}
     * @memberof TrackResult
     */
    atdAis?: Date;
    /**
     * 
     * @type {number}
     * @memberof TrackResult
     */
    sog?: number;
    /**
     * 
     * @type {Array<GeoJson>}
     * @memberof TrackResult
     */
    geo?: Array<GeoJson>;
    /**
     * 
     * @type {ERP}
     * @memberof TrackResult
     */
    erp?: ERP;
    /**
     * 
     * @type {Source}
     * @memberof TrackResult
     */
    source?: Source;
    /**
     * 
     * @type {Destination}
     * @memberof TrackResult
     */
    destination?: Destination;
    /**
     * Human readable description of the tracking status
     * @type {string}
     * @memberof TrackResult
     */
    message?: string;
    /**
     * Array of waypoints for the vessel's route
     * @type {Array<object>}
     * @memberof TrackResult
     */
    waypoints?: Array<object>;
    /**
     * 
     * @type {TrackResultTrack}
     * @memberof TrackResult
     */
    track?: TrackResultTrack;
}

/**
 * Check if a given object implements the TrackResult interface.
 */
export function instanceOfTrackResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TrackResultFromJSON(json: any): TrackResult {
    return TrackResultFromJSONTyped(json, false);
}

export function TrackResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'route': !exists(json, 'route') ? undefined : GeoJsonFromJSON(json['route']),
        'eta': !exists(json, 'eta') ? undefined : (new Date(json['eta'])),
        'etaErp': !exists(json, 'eta_erp') ? undefined : (new Date(json['eta_erp'])),
        'ataAis': !exists(json, 'ata_ais') ? undefined : (new Date(json['ata_ais'])),
        'atdAis': !exists(json, 'atd_ais') ? undefined : (new Date(json['atd_ais'])),
        'sog': !exists(json, 'sog') ? undefined : json['sog'],
        'geo': !exists(json, 'geo') ? undefined : ((json['geo'] as Array<any>).map(GeoJsonFromJSON)),
        'erp': !exists(json, 'erp') ? undefined : ERPFromJSON(json['erp']),
        'source': !exists(json, 'source') ? undefined : SourceFromJSON(json['source']),
        'destination': !exists(json, 'destination') ? undefined : DestinationFromJSON(json['destination']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'waypoints': !exists(json, 'waypoints') ? undefined : json['waypoints'],
        'track': !exists(json, 'track') ? undefined : TrackResultTrackFromJSON(json['track']),
    };
}

export function TrackResultToJSON(value?: TrackResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'route': GeoJsonToJSON(value.route),
        'eta': value.eta === undefined ? undefined : (value.eta.toISOString()),
        'eta_erp': value.etaErp === undefined ? undefined : (value.etaErp.toISOString()),
        'ata_ais': value.ataAis === undefined ? undefined : (value.ataAis.toISOString()),
        'atd_ais': value.atdAis === undefined ? undefined : (value.atdAis.toISOString()),
        'sog': value.sog,
        'geo': value.geo === undefined ? undefined : ((value.geo as Array<any>).map(GeoJsonToJSON)),
        'erp': ERPToJSON(value.erp),
        'source': SourceToJSON(value.source),
        'destination': DestinationToJSON(value.destination),
        'message': value.message,
        'waypoints': value.waypoints,
        'track': TrackResultTrackToJSON(value.track),
    };
}

